import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const GhostObjectIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Ghost shape - cute ghost with wavy bottom (larger) */}
      {/* Ghost body */}
      <path
        d="M12 1C7.03 1 3 5.03 3 10V21L5 19L7 21L9 19L11 21L12 20L13 21L15 19L17 21L19 19L21 21V10C21 5.03 16.97 1 12 1Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        opacity="0.8"
      />
      {/* Left eye */}
      <circle cx="9" cy="10" r="1.8" fill={color} opacity="0.9" />
      {/* Right eye */}
      <circle cx="15" cy="10" r="1.8" fill={color} opacity="0.9" />
    </BaseIcon>
  ),
);

GhostObjectIcon.displayName = 'GhostObjectIcon';
